import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export function CustomDatePicker({ date, setDate }) {
    return (
        <DatePicker
            selected={date}
            onChange={date => setDate(date)}
            
        />
    );
}